(ns frontend.actions.stages
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

;; NOTE
;; Should be one-to-one mapping with domain/account
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *->disable [data on-success! on-error!]
  (-> (conn/sendp! :stage/disable!
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->reorder! [data on-success! on-error!]
  (-> (conn/sendp! :stage/reorder data)
      (p/then on-success!)
      (p/catch on-error!)))
